import { NavLink, Outlet } from "react-router-dom";
import { HeartPulse } from "lucide-react";

export default function HealthLayout() {
  const tabs = [
    { to: "/pillar/health/my-health", label: "Dashboard", end: true },
    { to: "/pillar/health/my-health/devices", label: "Devices" },
    { to: "/pillar/health/my-health/connections", label: "Connections" },
  ];

  return (
    <div className="px-5 md:px-8 py-8 max-w-[1500px]">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-3 h-3 rounded-full" style={{ backgroundColor: "#8FB9B2" }} />
        <span className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">Health</span>
      </div>
      <h1 className="font-serif text-3xl md:text-4xl text-foreground flex items-center gap-3 mb-6">
        <HeartPulse className="w-7 h-7 text-muted-foreground" strokeWidth={1.5} /> My Health
      </h1>

      <nav className="flex gap-1 overflow-x-auto quiet-scroll border-b border-border mb-8" data-testid="health-tabs">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={`health-tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `px-3.5 py-2.5 text-sm whitespace-nowrap border-b-2 -mb-px transition-colors duration-200 ${
                isActive
                  ? "border-foreground text-foreground font-medium"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
